import isIpad from '../isIpad';
import isMobile from '../isMobile';

const isMobileOrIpad = () => isMobile() || isIpad();

export default isMobileOrIpad;
